// import React from 'react'
// import styles from "../../../src/asset/WhatWeDo/WhatWeDo.module.scss"

// const WhatWeDo = () => {
//   return (
//     <div>WhatWeDo</div>
//   )
// }

// export default WhatWeDo

import React from "react";
import styles from "../../../src/asset/WhatWeDo/WhatWeDo.module.scss"
import Imgage1 from "../../asset/homefour/FILE1.webp"
import Imgage2 from "../../asset/homefour/FILE3.webp"
import Imgage3 from "../../asset/images/img3.jpg"
import Imgage4 from "../../asset/homefour/FILE4.webp"
import { Link } from "react-router-dom";


const WhatWeDo = () => {
  const services = [
    { img: "../../asset/images/bgimg.jpg", title: "Artwork" },
    { img: "/images/digitizing.png", title: "Digitizing" },
    { img: "/images/namedrop.png", title: "Namedrop" },
    { img: "/images/printdesign.png", title: "Print Design" },
  ];

  return (
    <section className={styles.whatWeDo}>
      <div className={styles.overlay}>
        <div className={styles.header}>
          <h5>WHAT WE DO</h5>
          <h2>
            We provide  wide  range of design <br /> solutions
          </h2>
        </div>

      <div className={styles.services}>
  <Link to="/service#artwork" className={styles.card}>
    <img src={Imgage1} alt="" />
    <div className={styles.cardTitle}>Artwork</div>
  </Link>

  <Link to="/service#digitizing" className={styles.card}>
    <img src={Imgage2} alt="" />
    <div className={styles.cardTitle}>Digitizing</div>
  </Link>

  <Link to="/service#namedrop" className={styles.card}>
    <img src={Imgage3} alt="" />
    <div className={styles.cardTitle}>Namedrop</div>
  </Link>

  <Link to="/service#print-design" className={styles.card}>
    <img src={Imgage4} alt="" />
    <div className={styles.cardTitle}>Print Design</div>
  </Link>
</div>


      </div>
    </section>
  );
};

export default WhatWeDo;
